export default __webpack_public_path__ + "static/bg_gas-a4b84627ae52d3196a9dbe2b273fbb10.mp4";